const photoContainers = document.querySelectorAll(".singleNews-photoContainer");

for (const container of photoContainers) {
    showNewsSlides(1, container);
}

function changeNewsSlides(n, event) {
    const parentEl = event.target.closest(".singleNews-photoContainer");
    let currentPhotoIndex = +parentEl.querySelector(".dots.active").dataset.slide;
    showNewsSlides(currentPhotoIndex += n, event.target);
}

function currentNewsSlide(n, event) {
    showNewsSlides(n, event.target);
}

function showNewsSlides(n, el) {
    const currentPhotoContainer = el.closest(".singleNews-photoContainer");
    const slides = currentPhotoContainer.getElementsByClassName("newsSlides");
    let newsPhotoIndex = n;

        if (slides.length > 0)
        {
            const dotsList = []
            for (let i = 0; i < slides.length; i++) {
                dotsList.push(`<a class="dots" onclick="currentNewsSlide(${i + 1}, event)" data-slide="${i+1}"></a>`)
            };
            currentPhotoContainer.getElementsByClassName("dotsContainer")[0].innerHTML = dotsList.join('');
            const dots = currentPhotoContainer.getElementsByClassName("dots");
            if (n > slides.length) { newsPhotoIndex = 1 };
            if (n < 1) { newsPhotoIndex = slides.length };
            for (let i = 0; i < slides.length; i++) {
                slides[i].style.display = "none";
            };
            for (let i = 0; i < dots.length; i++) {
                dots[i].className = dots[i].className.replace(" active", "");
            };
            slides[newsPhotoIndex - 1].style.display = "block";
            dots[newsPhotoIndex - 1].className += " active";
        }
}


const newsOtherNewsSlider = new Swiper('.news-other-news-slider', {
  navigation: {
  nextEl: '.news-other-news-block .swiper-btn-next',
  prevEl: '.news-other-news-block .swiper-btn-prev',
  },
    breakpoints: {
        0: {
            slidesPerView: 'auto',
            spaceBetween: 0,
            centeredSlides: true,
            centeredSlidesBounds: false
        },
        768: {
            slidesPerView: 2,
            spaceBetween: 32,
            centeredSlides: false,
            centeredSlidesBounds: false
        },
        1600: {
            slidesPerView: 3,
            spaceBetween: 32,
            centeredSlides: false,
            centeredSlidesBounds: false
        }
    },
    watchSlidesVisibility: true,
    setWrapperSize: true,
    allowTouchMove: true
});